export enum TextFieldAutoSize {
    NONE = "none",
    LEFT = "left",
    CENTER = "center",
    RIGHT = "right",
}
